import React, { useEffect, useRef, useState } from "react";
import LeftScheduling from "./Planning";
import RightScheduling from "./Calendar";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useTranslate } from "@tolgee/react";
import { useDispatch, useSelector } from "react-redux";
import { lomavisCreatorRootState } from "../../../../pages/lomavisCreator";
import {
  mainToTempScheduleData,
  setModalUiContent,
  tempToMainScheduleData,
  updateRecurringStatus,
} from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import { relocatePublishButtons } from "../../utils/uploadMediaFile";
import { validateRecurrenceString } from "../../utils/helpers";
import toast from "react-hot-toast";
import { VIEW_STATUS } from "../../config/constants";

const SchedulingModal = ({ onClose }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { locationslug } = useParams();
  const [rightMargin, setRightMargin] = useState(0);
  const [currentViewDisplayed, setCurrentViewDisplayed] = useState<String>(
    VIEW_STATUS.PLANNING
  );

  const scheduleData = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.schedulePlanningData
  );

  const recurrenceData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.recurrence_as_str
  );

  const postData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData
  );

  const footerRef = useRef(null);

  useEffect(() => {
    relocatePublishButtons({ footerRef, setRightMargin });
  }, []);
  useEffect(() => {
    dispatch(updateRecurringStatus({}));
  }, [scheduleData.time, scheduleData.recurrence_as_str]);

  useEffect(() => {
    dispatch(mainToTempScheduleData());
  }, []);

  return (
    <div className="d-flex flex-column gap-4 w-100 h-100 ">
      <div
        style={{ overflowY: "hidden" }}
        className="d-flex justify-content-between w-100 gap-4 flex-fill"
      >
        <div
          style={{
            width: "40%",
            overflowX: "hidden",
          }}
          className="bg-white rounded-3 p-2"
        >
          <LeftScheduling
            currentViewDisplayed={currentViewDisplayed}
            setCurrentViewDisplayed={setCurrentViewDisplayed}
          />{" "}
        </div>{" "}
        <div
          className="bg-white rounded-3 h-100 px-2 py-1"
          style={{
            width: "60%",
            overflow: "hidden",
          }}
        >
          <RightScheduling locationslug={locationslug} />
        </div>
      </div>

      <div
        ref={footerRef}
        style={{ bottom: "0", zIndex: 100, height: "60px" }}
        className="w-100 d-flex justify-content-end gap-3 align-items-center bg-white py-2 border-top rounded-3"
      >
        <Button onClick={() => onClose()} variant="secondary" size="sm">
          {t("lomavisCreator.back")}
        </Button>
        <Button
          style={{ marginRight: rightMargin + "px" }}
          variant="primary"
          size="sm"
          onClick={() => {
            if (currentViewDisplayed === VIEW_STATUS.RECURRING_POSTS) {
              const recurrenceCheck = validateRecurrenceString(
                scheduleData.recurrence_as_str
              );
              if (!recurrenceCheck.valid) {
                const messageKey =
                  recurrenceCheck.reason === "weekly_no_day"
                    ? "lomavisCreator.postSchedule.weeklyMissingDay.toast"
                    : "lomavisCreator.postSchedule.save.toast";
                toast.error(t(messageKey), { position: "top-right" });
                return;
              }
            }

            dispatch(tempToMainScheduleData());

            dispatch(
              setModalUiContent({
                modal: "schedule",
                attribute: "toggle",
                value: false,
              })
            );
          }}
        >
          {recurrenceData ||
          Object.values(postData).some(
            (item) =>
              item?.tempPublicationData.datetime !== "" &&
              item?.tempPublicationData.datetime !== null
          )
            ? t("lomavisCreator.save_button")
            : t("lomavisCreator.save_schedule_button")}
        </Button>
      </div>
    </div>
  );
};

export default SchedulingModal;
